import styled from 'styled-components';

export const RouterTabListComponent = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-bottom: 30px;
    width: 100%;
    overflow: auto;
`;
